import { render, staticRenderFns } from "./Itens.vue?vue&type=template&id=06474c57&scoped=true&"
import script from "./Itens.vue?vue&type=script&lang=ts&"
export * from "./Itens.vue?vue&type=script&lang=ts&"
import style0 from "./Itens.vue?vue&type=style&index=0&id=06474c57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06474c57",
  null
  
)

export default component.exports